fragment userFields on User {
  id
  emails
  profile {
    firstName
    lastName
    imageUrl
  }
  adminRoles
}
